import React, { Component } from 'react';
import client from '../lib/shopify';

const ShopContext = React.createContext();

const FALLBACK_PRODUCTS = [
    {
        id: 'kodu-tara-sticker-fallback',
        title: 'Kodu Tara Akıllı QR Sticker',
        handle: 'kodu-tara-sticker',
        description: 'Aracınıza veya dükkanınıza Kodu Tara sticker’ınızı yapıştırarak, insanların size hızlıca ulaşmasını sağlayın. Kolay kurulum, güvenli iletişim!',
        variants: [
            {
                id: 'fallback-variant-1',
                title: 'Standart',
                price: {
                    amount: '299.90',
                    currencyCode: 'TL'
                }
            }
        ],
        images: [
            { src: '/banner/sticker.png', altText: 'Kodu Tara Sticker - Ön' },
            { src: '/banner/sticker1.png', altText: 'Kodu Tara Sticker - Detay' }
        ]
    }
];

export class ShopProvider extends Component {
    state = {
        product: {},
        products: [],
        checkout: {},
        isCartOpen: false,
        test: 'test',
        isShopifyAvailable: true
    };

    componentDidMount() {
        this.initShop();
    }

    initShop = async () => {
        try {
            if (localStorage.checkout_id) {
                await this.fetchCheckout(localStorage.checkout_id);
            } else {
                await this.createCheckout();
            }
        } catch (e) {
            console.warn("Shopify init error (handled):", e);
        }
    };

    createCheckout = async () => {
        try {
            if (!client || !client.checkout) return;
            const checkout = await client.checkout.create();
            if (checkout && checkout.id) {
                localStorage.setItem("checkout_id", checkout.id);
                this.setState({ checkout: checkout, isShopifyAvailable: true });
            }
        } catch (error) {
            console.warn("Shopify createCheckout error (handled):", error?.message || error);
            this.setState({ isShopifyAvailable: false });
        }
    };

    fetchCheckout = async (checkoutId) => {
        try {
            if (!client || !client.checkout) return;
            const checkout = await client.checkout.fetch(checkoutId);
            if (checkout && checkout.id && !checkout.completedAt) {
                this.setState({ checkout: checkout, isShopifyAvailable: true });
            } else {
                localStorage.removeItem("checkout_id");
                await this.createCheckout();
            }
        } catch (error) {
            console.warn("Shopify fetchCheckout error (handled):", error?.message || error);
            localStorage.removeItem("checkout_id");
            this.setState({ isShopifyAvailable: false });
        }
    };

    addItemToCheckout = async (variantId, quantity) => {
        try {
            if (!this.state.isShopifyAvailable || !this.state.checkout?.id || !client?.checkout) {
                alert("Online mağaza sistemi şu anda bakımda. Lütfen Trendyol, Hepsiburada veya Amazon üzerinden sipariş veriniz.");
                return;
            }
            const lineItemsToAdd = [
                {
                    variantId,
                    quantity: parseInt(quantity, 10),
                },
            ];
            const checkout = await client.checkout.addLineItems(
                this.state.checkout.id,
                lineItemsToAdd
            );
            this.setState({ checkout: checkout });
            this.openCart();
        } catch (error) {
            console.warn("Shopify addItemToCheckout error (handled):", error);
            alert("Sipariş sistemi şu anda bakımda. Lütfen alternatif mağazalarımızdan (Trendyol / Hepsiburada / Amazon) sipariş veriniz.");
        }
    };

    updateLineItemQuantity = async (lineItemId, quantity) => {
        try {
            if (!this.state.checkout?.id || !client?.checkout) return;
            const lineItemsToUpdate = [
                {
                    id: lineItemId,
                    quantity: parseInt(quantity, 10),
                },
            ];
            const checkout = await client.checkout.updateLineItems(
                this.state.checkout.id,
                lineItemsToUpdate
            );
            this.setState({ checkout: checkout });
        } catch (error) {
            console.warn("Shopify updateLineItemQuantity error (handled):", error);
        }
    };

    fetchAllProducts = async () => {
        try {
            if (!client || !client.product) {
                this.setState({ products: FALLBACK_PRODUCTS });
                return;
            }
            const products = await client.product.fetchAll();
            if (products && products.length > 0) {
                this.setState({ products: products });
            } else {
                this.setState({ products: FALLBACK_PRODUCTS });
            }
        } catch (error) {
            console.warn("Shopify fetchAllProducts error (handled, using fallback):", error?.message || error);
            this.setState({ products: FALLBACK_PRODUCTS, isShopifyAvailable: false });
        }
    };

    fetchProductWithHandle = async (handle) => {
        try {
            if (!client || !client.product) {
                const found = FALLBACK_PRODUCTS.find(p => p.handle === handle) || FALLBACK_PRODUCTS[0];
                this.setState({ product: found });
                return;
            }
            const product = await client.product.fetchByHandle(handle);
            if (product) {
                this.setState({ product: product });
            } else {
                const found = FALLBACK_PRODUCTS.find(p => p.handle === handle) || FALLBACK_PRODUCTS[0];
                this.setState({ product: found });
            }
        } catch (error) {
            console.warn("Shopify fetchProductWithHandle error (handled):", error?.message || error);
            const found = FALLBACK_PRODUCTS.find(p => p.handle === handle) || FALLBACK_PRODUCTS[0];
            this.setState({ product: found });
        }
    };

    closeCart = () => {
        this.setState({ isCartOpen: false });
    };

    openCart = () => {
        this.setState({ isCartOpen: true });
    };

    render() {
        return (
            <ShopContext.Provider
                value={{
                    ...this.state,
                    addItemToCheckout: this.addItemToCheckout,
                    updateLineItemQuantity: this.updateLineItemQuantity,
                    fetchAllProducts: this.fetchAllProducts,
                    fetchProductWithHandle: this.fetchProductWithHandle,
                    closeCart: this.closeCart,
                    openCart: this.openCart,
                }}
            >
                {this.props.children}
            </ShopContext.Provider>
        );
    }
}

const ShopConsumer = ShopContext.Consumer;

export { ShopConsumer, ShopContext };

export default ShopProvider;

